import "./UnitCard.scss"
import React from "react";
import {UnitGroupFloorSelector} from "../floor/UnitGroupFloorSelector";
import {IUnitGroup} from "../../interfaces/IUnitGroup";
import {UnitFavAction} from "../fav/UnitFavAction";
import {UnitImages} from "./UnitImages";

export interface IUnitCardProps {
  currency: string
  unitGroup: IUnitGroup
  floorSelector: boolean
}

export function UnitCard(p: IUnitCardProps) {
  return <>
    <UnitFavAction unitGroupId={p.unitGroup.id}/>
    <UnitImages images={p.unitGroup.images}/>
    {p.floorSelector?<UnitGroupFloorSelector unitGroup={p.unitGroup} currency={p.currency}/>:null}
  </>
}